<header class="app-header navbar noselect">
  <div class="navbar-brand"></div>
  <app-header-right-content />
</header>

<div class="dashboard-content app-body">
  <div class="p-4">
    <h1>
      {{
        "openProjectComponent.greeting"
          | translate
            : {
                "0":
                  getGreetingName() ||
                  ("openProjectComponent.greeting.guest" | translate),
              }
      }}
    </h1>
    <p>{{ "openProjectComponent.description_short" | translate }}</p>
  </div>

  <div class="hero">
    <div class="hero-content">
      <div class="tiles-wrapper">
        <app-tile-button
          id="my-projects"
          *ngIf="isMyProjectsEnabled()"
          (click)="openProject()"
          icon="folder"
          [text]="'projectNavigation.my_projects' | translate"
        >
        </app-tile-button>
        <app-tile-button
          id="create-configuration"
          (click)="openNewConfigurationDialog()"
          icon="plus"
          [text]="'openProjectComponent.label.create_configuration' | translate"
        >
        </app-tile-button>
        <app-tile-button
          id="open-from-template"
          (click)="openCreateFromTemplateWizard()"
          icon="applications"
          [text]="'configurationCreation.type.template' | translate"
        >
        </app-tile-button>
        <app-tile-button
          id="import-project"
          (click)="openImportChoiceDialog()"
          icon="import"
          [text]="'openProjectComponent.label.import' | translate"
        >
        </app-tile-button>
        <app-tile-link
          id="howto-videos-link"
          icon="external-link"
          [text]="'openProjectComponent.label.howto_videos' | translate"
          [href]="'openProjectComponent.label.howto_videos_url' | translate"
        >
        </app-tile-link>
      </div>
    </div>
  </div>

  <div class="p-4 disclaimer">
    {{ "main.message.startup_configurator_hint" | translate }}
  </div>
</div>
